import { types } from 'mobx-state-tree';

import InquiryType from '../types/InquiryType';
import { Inquiry as BaseInquiry } from '../definitions/Common';


const Inquiry = types
    .model({
        type: types.maybe(InquiryType),
    });

export default types.compose('Inquiry', BaseInquiry, Inquiry);
